// Import Packages
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from "recoil";

// Import Material UI
import { IconButton, Button, Tooltip, Slide } from '@material-ui/core';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import Divider from '@material-ui/core/Divider';

// Import Pages
import AppIcon from "../../../../../../../assets/icons/triggerIcons/App";
import APIIcon from "../../../../../../../assets/icons/triggerIcons/API";
import ScheduleIcon from "../../../../../../../assets/icons/triggerIcons/Schedule";
import WebhookIcon from "../../../../../../../assets/icons/triggerIcons/Webhook";
import EmailIcon from "../../../../../../../assets/icons/triggerIcons/Email";
import TriggerCloseIcon from "../../../../../../../assets/icons/triggerIcons/TriggerClose";
import TriggerResetIcon from "../../../../../../../assets/icons/triggerIcons/trigger-reset-icon.svg";
import { triggerConf, triggerSelection } from "../../../../../../../recoil-store/recoil-state";


// Import Helpers
import { capitalizeFirstLetter, conditionalOperators } from "../../../../../../../helpers/helper";

// Import CSS

const TriggerItem = ({ setTriggerArea, setTriggerModal, setOpenSchedule, setTriggerType, item, handleResetTrigger, config }) => {
    const { t } = useTranslation();
    const [openSetTriggerType, setOpenSetTriggerType] = useState(false);
    const [triggerSelectionData, setTriggerSelectionData] = useRecoilState(triggerSelection);
    const triggerStaticTriggerLabel = "CONTENT.CONFIGURATION-FORM.TRIGGER-STATIC.TRIGGERS."
    const [triggerConfig, setTriggerConfig] = useRecoilState(triggerConf);
    const label = 'CONTENT.FLOW.'

    const setTriggerSelection = (e) => {
        e.stopPropagation();
        setOpenSetTriggerType(true);
    }
    const confirmTrigger = async (type) => {
        const res = await setTriggerType(type)
        setTriggerSelectionData(res)
        setOpenSetTriggerType(false)
    }
    if (config) {
        return <>{item?.actionName === 'TRIGGER' && (Object.keys(triggerConfig.app).length > 0 || triggerSelectionData.length > 0) && (
            <Tooltip placement="top" title={t(label + 'RESET-TRIGGER-CONFIG')}>
                <IconButton
                    size='small'
                    style={{
                        right: -8,
                        top: -8,
                        position: 'absolute',
                        padding: 3,
                        backgroundColor: "rgb(215, 94, 94)",


                    }}
                    onClick={(e) => handleResetTrigger(e)}
                >
                    <RotateLeftIcon
                        fontSize='small'
                        style={{
                            fontSize: 22,
                            color: 'white',
                            display: Object.keys(triggerConfig.app).length > 0 ? 'inline-block !important' : 'none !important'
                        }}
                    />

                </IconButton>
            </Tooltip>
        )}</>
    }
    else {
        return <div className="new-flow-row" id='new-flow-row'>
            <div className="trigger-panel">
                {item?.actionName === 'TRIGGER' && (Object.keys(triggerConfig.app).length > 0 || triggerSelectionData.length > 0) && (
                    <Tooltip placement="top" title={t(label + 'RESET-TRIGGER-CONFIG')}>
                        <IconButton
                            size='small'
                            style={{
                                right: -8,
                                top: -8,
                                position: 'absolute',
                                padding: 6,
                                backgroundColor: "rgb(215, 94, 94)",


                            }}
                            onClick={(e) => handleResetTrigger(e)}
                        >
                            {/* <RotateLeftIcon
                                fontSize='small'
                                style={{
                                    fontSize: 22,
                                    color: 'white',
                                    display: Object.keys(triggerConfig.app).length > 0 ? 'inline-block !important' : 'none !important'
                                }}
                            /> */}
                            <img src={TriggerResetIcon} style={{
                                width: "12px",
                                height: "12px",
                                color: 'white',
                                display: Object.keys(triggerConfig.app).length > 0 ? 'inline-block !important' : 'none !important'
                            }} />

                        </IconButton>
                    </Tooltip>
                )}
                <h3>
                    {triggerSelectionData.length > 0 ?
                        (
                            <div className="trigger-type-section">
                                {triggerSelectionData.map((item, index) => {
                                    return (
                                        // item === "app" ? (
                                        //     <Tooltip title={t(triggerStaticTriggerLabel + "APP")}
                                        //         placement="top" key={index}>
                                        //         <div className="trigger-selection-item active">
                                        //             <AppIcon />
                                        //             <div className="divider-x active"></div>
                                        //             <span>{t(triggerStaticTriggerLabel + "APP")}</span>
                                        //         </div>
                                        //     </Tooltip>
                                        // ) : 
                                        item === "webhook" ? (
                                            <Tooltip title={t(triggerStaticTriggerLabel + "WEBHOOK")}
                                                placement="top" key={index}>
                                                <div className="trigger-selection-item active">
                                                    <WebhookIcon />
                                                    <div className="divider-x active"></div>
                                                    <span>{t(triggerStaticTriggerLabel + "WEBHOOK")}</span>
                                                </div>
                                            </Tooltip>
                                        ) : item === "email" ? (
                                            <Tooltip title={t(triggerStaticTriggerLabel + "EMAIL")}
                                                placement="top" key={index}>
                                                <div className="trigger-selection-item active">
                                                    <EmailIcon />
                                                    <div className="divider-x active"></div>
                                                    <span>{t(triggerStaticTriggerLabel + "EMAIL")}</span>
                                                </div>
                                            </Tooltip>
                                        ) : item === "api" ? (
                                            <Tooltip title={t(triggerStaticTriggerLabel + "API")}
                                                placement="top" key={index}>
                                                <div className="trigger-selection-item active">
                                                    <APIIcon />
                                                    <div className="divider-x active"></div>
                                                    <span>{t(triggerStaticTriggerLabel + "API")}</span>
                                                </div>
                                            </Tooltip>
                                        ) : item === "schedule" ? (
                                            <Tooltip title={t(triggerStaticTriggerLabel + "SCHEDULE")}
                                                placement="top" key={index}>
                                                <div className="trigger-selection-item active">
                                                    <ScheduleIcon />
                                                    <div className="divider-x active"></div>
                                                    <span>{t(triggerStaticTriggerLabel + "SCHEDULE")}{config}</span>
                                                </div>
                                            </Tooltip>
                                        ) : null
                                    )
                                })}
                            </div>
                        ) :
                        (
                            t(triggerStaticTriggerLabel + 'TRIGGER')
                        )
                    }
                </h3>
                {
                    triggerSelectionData.length > 0 ? (
                        triggerSelectionData.includes('app') ? (
                            triggerConfig && Object.keys(triggerConfig.trigger).length > 0 ? (
                                <div className='trigger-item-container'>
                                    <div
                                        className="trigger-pane">{t(triggerStaticTriggerLabel + triggerConfig.trigger?.name)} ({capitalizeFirstLetter(triggerConfig.trigger?.type)})
                                    </div>
                                    {triggerConfig.setup.conditions?.length > 0 && triggerConfig.setup.conditions[0].condition !== "" && (
                                        <div className="add-trigger-setup-block">
                                            {triggerConfig.setup.conditions.map((item, i) => {
                                                let prevItem;
                                                if (i - 1 >= 0) prevItem = triggerConfig.setup.conditions[i - 1];
                                                return (
                                                    <>
                                                        {item.source.length > 0 && item.condition !== "" && (
                                                            <>
                                                                {prevItem && prevItem.op_logic && prevItem.source.length > 0 && prevItem.condition !== "" && (
                                                                    <div className="op-logic-area">
                                                                        {prevItem.op_logic.toUpperCase()}
                                                                    </div>
                                                                )}
                                                                <div key={i}
                                                                    className="condition-block">
                                                                    <div className="source-area">
                                                                        <span className="if-block">
                                                                            {`# ${i + 1} ` + t("CONTENT.FLOW.CONDITION")}
                                                                        </span>
                                                                        <span
                                                                            className="if-selection source-datas">
                                                                            <div
                                                                                className='condition-source-container'>
                                                                                {
                                                                                    item.source?.map((v, i) => {
                                                                                        return <div
                                                                                            className="source-param" key={i}>{v.text}</div>
                                                                                    })
                                                                                }
                                                                            </div>

                                                                            <div
                                                                                className="condition-param">{conditionalOperators[item.condition]?.text}</div>
                                                                        </span>
                                                                        {item.condition !== "e" && item.condition !== "ne" && item.target !== "" && (
                                                                            <>
                                                                                <Divider
                                                                                    style={{ backgroundColor: '#e6e6e6' }} />
                                                                                <span
                                                                                    className="if-selection">
                                                                                    <div
                                                                                        className="source-param">{item.target}</div>
                                                                                </span>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </>
                                                )
                                            })}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className='trigger-button-container'>
                                    <Button onClick={setTriggerArea} className='trigger-button'
                                        variant="contained">
                                        {t(triggerStaticTriggerLabel + 'CONFIGURE-TRIGGER')}
                                    </Button>
                                    {/* <Button onClick={setTriggerSelection} className='trigger-button test-trigger'
                                        variant="contained">
                                        {t(triggerStaticTriggerLabel + 'TEST-TRIGGER')}
                                    </Button> */}
                                </div>
                            )
                        ) : triggerSelectionData.includes('webhook') || triggerSelectionData.includes('api') || triggerSelectionData.includes('email') ? (
                            <div className='trigger-button-container'>
                                <Button onClick={setTriggerModal} className='trigger-button'
                                    variant="contained">
                                    {t(triggerStaticTriggerLabel + 'CONFIGURE-TRIGGER')}
                                </Button>
                                {/* <Button onClick={setTriggerSelection} className='trigger-button test-trigger'
                                    variant="contained">
                                    {t(triggerStaticTriggerLabel + 'TEST-TRIGGER')}
                                </Button> */}
                            </div>
                        ) : triggerSelectionData.includes('schedule') ? (
                            <div>
                                <Button onClick={setOpenSchedule} className='trigger-button'
                                    variant="contained">
                                    {t(triggerStaticTriggerLabel + 'CONFIGURE-TRIGGER')}
                                </Button>
                            </div>
                        ) : (
                            <></>
                        )
                    ) : (
                        <div style={{ position: "relative" }}>
                            {!openSetTriggerType && (
                                <>
                                    <Button onClick={setTriggerSelection} className='trigger-button set-trigger-button'
                                        variant="contained">
                                        {t(triggerStaticTriggerLabel + 'SET-TRIGGER-TYPE')}
                                    </Button>
                                    {/* <Button onClick={setTriggerSelection} className='trigger-button test-trigger'
                                        variant="contained">
                                        {t(triggerStaticTriggerLabel + 'SET-TRIGGER-TYPE')}
                                    </Button> */}
                                </>
                            )}
                            {openSetTriggerType && (
                                <>
                                    <div className="trigger-type-row">
                                        {/* <div className="trigger-selection-item"
                                            onClick={() => confirmTrigger("app")}>
                                            <AppIcon />
                                            <div className="divider-x"></div>
                                            <span>{t(triggerStaticTriggerLabel + "APP")}</span>
                                        </div> */}
                                        <div className="trigger-selection-item"
                                            onClick={() => confirmTrigger("webhook")}>
                                            <WebhookIcon />
                                            <div className="divider-x"></div>
                                            <span>{t(triggerStaticTriggerLabel + "WEBHOOK")}</span>
                                        </div>
                                        <div className="trigger-selection-item"
                                            onClick={() => confirmTrigger("api")}>
                                            <APIIcon />
                                            <div className="divider-x"></div>
                                            <span>{t(triggerStaticTriggerLabel + "API")}</span>
                                        </div>
                                    </div>
                                    <div className="trigger-type-row">
                                        <div className="trigger-selection-item"
                                            onClick={() => confirmTrigger("email")}>
                                            <EmailIcon />
                                            <div className="divider-x"></div>
                                            <span>{t(triggerStaticTriggerLabel + "EMAIL")}</span>
                                        </div>
                                        <div className="trigger-selection-item"
                                            onClick={() => confirmTrigger("schedule")}>
                                            <ScheduleIcon />
                                            <div className="divider-x"></div>
                                            <span>{t(triggerStaticTriggerLabel + "SCHEDULE")}</span>
                                        </div>
                                    </div>
                                    <div className="trigger-selection-close"
                                        onClick={() => setOpenSetTriggerType(false)}>
                                        <TriggerCloseIcon />
                                    </div>
                                </>
                            )}
                        </div>
                    )
                }
            </div>
        </div>
    }




}
export default TriggerItem